import React from "react";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import group228 from "../../../../../../assets/images/Group 228.png";
import "./CongratulationModal.css";

const CongratulationModal = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body
        style={{ backgroundColor: "#000000", border: "1px solid #DDA336" }}
      >
        <div className="d-flex justify-content-end">
          <Button className="continue-button" onClick={props.onHide}>
            X
          </Button>
        </div>

        <div className="row">
          <div className="col-md-7 text-warning">
            <h2 className="card-text  fw-bold">Congratulations ! </h2>
            <h3 className="superStarName">{localStorage.auth_name}</h3>
            <h4 className="ps-text fw-bold">
              {localStorage.auth_type === "star"
                ? "Dear Superstar"
                : "Dear Jury Member"}
            </h4>
            <p className="my-3 ps-text">
              Are you ready to enter dashboard?
              <br />
              Please continue....!
            </p>
          </div>
          <div className="col-md-5">
            <img className="img-fluid" src={group228} alt="" />
          </div>
        </div>

        <div className="d-flex justify-content-center mt-5">
          <Link
            to={
              localStorage.auth_type === "star"
                ? "/superstar/dashboard"
                : "/jury-board/dashboard"
            }
          >
            <button className="btn btnCreate w-100 ">Continue</button>
          </Link>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CongratulationModal;
